// extracted by mini-css-extract-plugin
module.exports = {"root":"SubscriptionPlanStep_root__3kPrE","header":"SubscriptionPlanStep_header__3RSVq","table":"SubscriptionPlanStep_table__1gITd","button":"SubscriptionPlanStep_button__3E4BP"};